import * as React from 'react'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'

interface IProps {
  label: string | React.ReactElement
  isLoading?: boolean
  width?: number
  height?: number
  onClick: () => void
}

const RegularButton: React.FC<IProps> = ({
  label,
  isLoading,
  width,
  height,
  onClick,
}) => {
  return (
    <Button
      variant="contained"
      sx={{
        color: '#FFFFFF',
        width: width ?? 'auto',
        height: height ?? 'auto',
      }}
      disabled={isLoading}
      onClick={onClick}
    >
      {!isLoading ? label : <CircularProgress color="inherit" size={20} />}
    </Button>
  )
}

export default RegularButton
